export const defaultTutorLanguages = {
    speak: [{ lang: "en", level: "C1" }],
    teach: [{ lang: "en", level: "C1" }],
};

export const defaultTutorBootstrapPayload = {
    teach: defaultTutorLanguages.teach,
    speak: defaultTutorLanguages.speak,
    description: "",
    youtube: "",
};

export const defaultWeekDays = [
    {
        day: 1,
        name: "Monday",
        slices: [{ start: 8, end: 18 }],
        off: false,
    },
    {
        day: 2,
        name: "Tuesday",
        slices: [{ start: 8, end: 18 }],
        off: false,
    },
    {
        day: 3,
        name: "Wednesday",
        slices: [{ start: 8, end: 18 }],
        off: false,
    },
    {
        day: 4,
        name: "Thursday",
        slices: [{ start: 8, end: 18 }],
        off: false,
    },
    {
        day: 5,
        name: "Friday",
        slices: [{ start: 8, end: 18 }],
        off: false,
    },
    {
        day: 6,
        name: "Saturday",
        slices: [{ start: 8, end: 18 }],
        off: false,
    },
    {
        day: 0,
        name: "Sunday",
        slices: [{ start: 8, end: 18 }],
        off: false,
    },
];
